<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24" class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <a-form-model-item label="告警信息" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <span>{{ model.summary || '-' }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label="持续时间(小时)"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="continueHours"
            >
              <a-input-number
                v-model="model.continueHours"
                @change="handleHoursChange"
                :min="1"
                :max="12"
                placeholder="请输入持续时间(小时)，最小1小时，最大12小时"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label="告警恢复时间"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="alertRecoverTime"
            >
              <a-input :disabled="true" v-model="model.alertRecoverTime" placeholder="告警恢复时间:"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="说明" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea v-model="model.remark" rows="4" placeholder="请输入说明" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'

export default {
  name: 'IotAlertWhitelistForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {
        enable: 1,
        continueHours: 8,
        alertRecoverTime: this.$moment()
          .add(8, 'hours')
          .format('YYYY-MM-DD HH:mm:ss')
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        alertRecoverTime: [{ required: true, message: '请输入告警恢复时间!' }],
        continueHours: [
          { required: true, message: '请输入告警持续时间!' },
          { pattern: /^-?\d+$/, message: '请输入整数!' }
        ]
      },
      url: {
        add: '/alert/iotAlertWhitelist/add',
        edit: '/alert/iotAlertWhitelist/edit',
        queryById: '/alert/iotAlertWhitelist/queryById'
      }
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    // 告警持续时间 input change
    handleHoursChange(hour) {
      const alertRecoverTime = this.$moment()
        .add(hour ?? 0, 'hours')
        .format('YYYY-MM-DD HH:mm:ss')
      this.model.alertRecoverTime = alertRecoverTime
    },
    add(record) {
      const { summary, ruleGroupId } = record
      this.edit({ ...this.modelDefault, summary, ruleGroupId })
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          this.model.groupCode = this.model.ruleGroupId
          httpAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
